module.exports = __webpack_public_path__ + "img/es.cc1b41b.svg";